import api from "@/assets/js/api";
// import axios from "@/assets/js/api";
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示

export default {
  data() {
    return {
      posts: [],
      filteredPosts: [],
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 10,
      showEditModal: false,
      showAddModal: false,
      editPostData: {
        id: "",
        title: "",
        contents: "",
        category: "",
        starttime: "",
        endtime: "",
        enabled: "",
        image: "",
        createdate: "",
        creator: "",
      },
      newPostData: {
        title: "",
        contents: "",
        category: "",
        starttime: "",
        endtime: "",
        enabled: true,
        image: "",
      },
    };
  },
  computed: {
    paginatedPosts() {
      return this.filteredPosts.slice(
        (this.currentPage - 1) * this.itemsPerPage,
        this.currentPage * this.itemsPerPage
      );
    },
    totalPages() {
      return Math.ceil(this.filteredPosts.length / this.itemsPerPage);
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
  },
  methods: {
    async fetchPosts() {
      try {
        const response = await api.get("/Posts");
        this.posts = response.data;
        this.updateFilteredPosts();
      } catch (error) {
        console.error("無法取得公告資料", error);
      }
    },

    // 搜尋公告功能:ID、標題、內容
    updateFilteredPosts() {
      this.filteredPosts = this.posts.filter(
        (post) =>
          post.id.toString().includes(this.searchQuery) || // 搜尋 ID
          post.title.includes(this.searchQuery) || // 搜尋標題
          post.contents.includes(this.searchQuery) // 搜尋內容
      );
      this.currentPage = 1; // 重置到第一頁
    },

    // 顯示全部公告
    showAllPosts() {
      this.filteredPosts = [...this.posts]; // 重置為所有公告
    },

    // 依據類別篩選
    filterPosts(category) {
      this.filteredPosts = this.posts.filter(
        (post) => post.category === category
      );
      this.currentPage = 1; // 重置到第一頁
    },

    // 日期格式
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 編輯公告相關
    editPost(post) {
      this.editPostData = {
        ...post,
        starttime: this.formatDate(post.starttime), // 將時間轉換為 YYYY-MM-DD 格式
        endtime: this.formatDate(post.endtime), // 同上
        image: post.image.split("/").pop(), // 獲取圖片名稱
      };
      this.showEditModal = true;
    },

    // 儲存編輯後的公告
    async saveEdit() {
      try {
        console.log("準備發送到後端的數據:", this.editPostData);

        if (!this.editPostData.id) {
          throw new Error("缺少公告 ID，無法保存");
        }

        const response = await api.put(
          `/Posts/${this.editPostData.id}`,
          this.editPostData
        );
        console.log("更新成功:", response.data);
        Swal.fire({
          icon: "success",
          title: "更新成功",
          text: "更新公告成功",
        });
        this.fetchPosts();
        this.showEditModal = false;
      } catch (error) {
        console.error("公告更新失敗:", error.response?.data || error.message);
        Swal.fire({
          icon: "error",
          title: "更新失敗",
          text: "公告更新失敗，請確認圖片是否上傳成功並重試。",
        });
      }
    },

    // 公告中的標題與內容文字超過幾個字就顯示...
    truncate(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + "..."; // 截取前幾個字並加上「...」
      }
      return text; // 如果字串長度不超過幾個字，則返回原字串
    },

    confirmDeletePost(id) {
      const isConfirmed = confirm("確認要刪除公告嗎?"); // 預設模態框
      if (isConfirmed) {
        this.deletePost(id); // 如果確認，直接呼叫刪除方法
      }
    },

    async deletePost(id) {
      try {
        await api.delete(`/Posts/${id}`); // 呼叫 API 刪除公告
        this.fetchPosts(); // 刪除後重新加載公告資料

        // ✅ 成功提示
        Swal.fire({
          icon: "success",
          title: "刪除成功",
          text: "成功刪除公告資料",
        });

        this.closeEditModal(); // 關閉編輯彈窗
      } catch (error) {
        console.error("刪除公告失敗", error);

        // ❌ 失敗提示
        Swal.fire({
          icon: "error",
          title: "刪除失敗",
          text: "刪除公告失敗，請稍後再試。",
        });
      }
    },

    closeDeleteConfirm() {
      this.showDeleteConfirm = false; // 關閉確認對話框
      this.postToDelete = null; // 重置要刪除的公告 ID
    },

    closeEditModal() {
      this.showEditModal = false;
    },

    // 打開新增公告視窗
    openAddModal() {
      this.showAddModal = true;
      this.newPostData = {
        // 重置數據
        title: "",
        contents: "",
        category: "最新消息",
        starttime: "",
        endtime: "",
        enabled: true,
        image: "",
      };
    },

    // 關閉新增公告視窗
    closeAddModal() {
      this.showAddModal = false;
    },

    // 處理檔案選擇
    async handleFileUpload(event) {
      const file = event.target.files[0]; // 獲取使用者選擇的檔案
      if (file) {
        try {
          const uploadedFileName = await this.uploadImageAsBase64(file); // 上傳圖片並獲取檔案名稱

          if (this.showAddModal) {
            this.newPostData.image = uploadedFileName; // 更新新增公告的圖片名稱
          } else if (this.showEditModal) {
            this.editPostData.image = uploadedFileName; // 更新編輯公告的圖片名稱
          }

          Swal.fire({
            icon: "success", // ✅ 成功圖示
            title: "成功",
            text: "圖片上傳成功", // 成功提示
          });
          
        } catch (error) {
          Swal.fire({
            icon: "error", // ❌ 錯誤圖示
            title: "上傳失敗",
            text: "圖片上傳失敗，請稍後再試。", // 錯誤提示
          });
          
        }
      }
    },

    // 新增公告
    async saveNewPost() {
      try {
        // 獲取當前使用者的 email 從 cookies 中
        const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
          const [key, value] = cookie.split("=");
          acc[key] = decodeURIComponent(value);
          return acc;
        }, {});
        const currentUserEmail = cookies["email"]; // 假設 cookies 中有一個 email 欄位

        // 呼叫後端 API 獲取使用者名稱
        const responseUser = await api.get(
          `/Posts/GetFullNameByEmail?email=${currentUserEmail}`
        );
        const currentUserName = responseUser.data.fullName || "Unknown"; // 如果後端返回空值，使用 "Unknown"

        // 發送公告資料到後端
        const responsePost = await api.post("/Posts", {
          ...this.newPostData,
          createdate: new Date(), // 設置當前時間
          creator: currentUserName, // 傳入獲取的名稱
        });

        console.log("即將送出的資料:", this.newPostData);

        console.log("新增公告成功:", responsePost.data);
        Swal.fire({
          icon: "success", // ✅ 成功圖示
          title: "新增成功",
          text: "新增公告成功", // 成功訊息
        });
        this.fetchPosts(); // 刷新公告列表
        this.closeAddModal(); // 關閉模態框
      } catch (error) {
        console.error("新增公告失敗:", error.response?.data || error.message);
        // 新增公告失敗提示
        Swal.fire({
          icon: "error", // ❌ 錯誤圖示
          title: "新增失敗",
          text: "新增公告失敗，請稍後再試。", // 錯誤訊息
        });
      }
    },

    // 上傳圖片
    // async uploadImage(file) {
    //   try {
    //     const formData = new FormData();
    //     formData.append("file", file);

    //     const response = await api.post("/Posts/upload", formData, {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     });

    //     // 返回後端提供的檔案名稱
    //     return response.data.fileName;
    //   } catch (error) {
    //     console.error("圖片上傳失敗:", error.response?.data || error.message);
    //     throw new Error("圖片上傳失敗");
    //   }
    // },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    },

    // 上傳圖片方法
    async uploadImageAsBase64(file) {
      try {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
          reader.onload = async () => {
            try {
              // 提取 Base64 資料
              const base64Data = reader.result.split(",")[1]; // 去掉 Base64 的前綴部分

              // 調用後端 API 傳送圖片
              const response = await api.post("/Posts/uploadBase64", {
                fileName: file.name, // 使用圖片原始名稱
                base64Data: base64Data,
              });

              // 返回上傳成功的檔案名稱
              resolve(response.data.fileName);
            } catch (error) {
              console.error(
                "圖片上傳失敗:",
                error.response?.data || error.message
              );
              reject(error);
            }
          };

          reader.onerror = (error) => {
            console.error("圖片讀取失敗:", error);
            reject(error);
          };

          // 將檔案讀取為 Base64
          reader.readAsDataURL(file);
        });
      } catch (error) {
        console.error("圖片處理失敗:", error);
        throw error;
      }
    },
  },
  mounted() {
    this.fetchPosts();
  },
};
